@if (isDateTime()) {
  <div>
    <form [formGroup]="form" class="space-y-4">
      <div class="space-y-3">
        @for (format of predefinedFormats; track $index) {
          <label class="flex items-center gap-3 cursor-pointer">
            <input
              type="radio"
              formControlName="selectedFormat"
              value="{{ format }}"
              class="w-4 h-4 text-main focus:ring-main" />
            <span class="text-base">{{ format }}</span>
          </label>
        }
        <label class="flex items-center gap-3 cursor-pointer">
          <input
            type="radio"
            formControlName="selectedFormat"
            value="custom"
            class="w-4 h-4 text-main focus:ring-main" />
          <span class="text-base">{{ 'propertyFormat.customFormat' | translate }}</span>
        </label>
      </div>
      <div class="mt-4">
        <label for="customFormat" class="sr-only">{{
          'propertyFormat.enterCustomFormat' | translate
        }}</label>
        <input
          id="customFormat"
          type="text"
          formControlName="customFormat"
          [placeholder]="'propertyFormat.enterCustomFormat' | translate"
          (focus)="onCustomFormatFocus()"
          [class]="
            'w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:border-transparent ' +
            (form.controls.customFormat.invalid && form.controls.customFormat.touched
              ? 'border-red-500 focus:ring-red-500'
              : 'border-gray-300 focus:ring-main')
          " />
        @if (form.controls.customFormat.invalid && form.controls.customFormat.touched) {
          <p class="mt-1 text-sm text-red-600">
            {{ 'propertyFormat.invalidFormat' | translate }}
          </p>
        }
      </div>
      @if (selectedFormatSignal() && datePreview()) {
        <div class="mt-4 p-3 bg-gray-50 border border-gray-200 rounded-lg">
          <div class="text-sm font-medium text-gray-700 mb-1">
            {{ 'propertyFormat.preview' | translate }}
          </div>
          <div class="text-base text-gray-900">{{ datePreview() }}</div>
        </div>
      }
      <div class="mt-4">
        <cmi-button
          [label]="buttonLabel() | translate"
          [loadingLabel]="'propertyFormat.applying' | translate"
          [loading]="isApplying()"
          [disabled]="!isFormValid()"
          (clicked)="onApply()" />
      </div>
    </form>
  </div>
}
@if (isBoolean()) {
  <div>
    <form [formGroup]="form" class="space-y-4">
      <div class="space-y-4">
        <div>
          <label for="trueValue" class="block text-base font-medium mb-2">{{
            'propertyFormat.trueValue' | translate
          }}</label>
          <input
            id="trueValue"
            type="text"
            formControlName="trueValue"
            [placeholder]="'propertyFormat.enterValueForTrue' | translate"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-main focus:border-transparent" />
        </div>
        <div>
          <label for="falseValue" class="block text-base font-medium mb-2">{{
            'propertyFormat.falseValue' | translate
          }}</label>
          <input
            id="falseValue"
            type="text"
            formControlName="falseValue"
            [placeholder]="'propertyFormat.enterValueForFalse' | translate"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-main focus:border-transparent" />
        </div>
      </div>
      <div class="mt-4">
        <cmi-button
          [label]="buttonLabel() | translate"
          [loadingLabel]="'propertyFormat.applying' | translate"
          [loading]="isApplying()"
          [disabled]="!isFormValid()"
          (clicked)="onApply()" />
      </div>
    </form>
  </div>
}
@if (isInt32()) {
  <div>
    <form [formGroup]="form" class="space-y-4">
      <div>
        <label for="decimalPlaces" class="block text-base font-medium mb-2">{{
          'propertyFormat.decimalPlaces' | translate
        }}</label>
        <input
          id="decimalPlaces"
          type="number"
          formControlName="decimalPlaces"
          min="0"
          [placeholder]="'propertyFormat.enterDecimalPlaces' | translate"
          [class]="
            'w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:border-transparent ' +
            (form.controls.decimalPlaces.invalid && form.controls.decimalPlaces.touched
              ? 'border-red-500 focus:ring-red-500'
              : 'border-gray-300 focus:ring-main')
          " />
        @if (form.controls.decimalPlaces.invalid && form.controls.decimalPlaces.touched) {
          <p class="mt-1 text-sm text-red-600">
            {{ 'propertyFormat.invalidDecimalPlaces' | translate }}
          </p>
        }
      </div>
      <div class="mt-4">
        <cmi-button
          [label]="buttonLabel() | translate"
          [loadingLabel]="'propertyFormat.applying' | translate"
          [loading]="isApplying()"
          [disabled]="!isFormValid()"
          (clicked)="onApply()" />
      </div>
    </form>
  </div>
}
